import api from './api'

/**
 * Serviço de integração com GitHub
 */
export default {
  /**
   * Verificar status da integração GitHub
   */
  getStatus() {
    return api.get('/api/integrations/github/status')
  },

  /**
   * Listar repositórios da organização/conta
   */
  getRepositories() {
    return api.get('/api/integrations/github/repositories')
  },
}
